import config from "config/config";
import { Entry } from "models/inventory/inventory";
import { apiRequest } from "./apiInterceptor";

export class InventoryAPI {
  static async getArticleRegister() {
    const response = await apiRequest
      .get(config.api.inventory.articleRegister.get);

    return response.body;
  }

  static async getFiscalYear(customerId: string) {
    const response = await apiRequest
      .get(config.api.fiscalyear.get(customerId));

    return response.body;
  }

  static async getInventories(customerId: string) {
    const response = await apiRequest
      .get(config.api.inventory.inventories.get(customerId));

    return response.body;
  }

  static async getInventory(customerId: string, inventoryId: number) {
    const response = await apiRequest
      .get(config.api.inventory.inventory.get(customerId, inventoryId));

    return response.body;
  }

  static async createInventory(customerId: string, perDate: string) {
    return await apiRequest
      .post(config.api.inventory.inventory.create(customerId))
      .send({
        customer_id: customerId,
        per_date: perDate,
        state_name: "created"
      });
  }

  static async createInventoryPdf(
    customerId: string,
    inventoryId: number,
    companyName: string,
    username: string
  ) {
    const response = await apiRequest
      .post(config.api.inventory.inventory.createPdf(customerId, inventoryId))
      .send({
        company_name: companyName,
        username: username
      });

    return response.body;
  }

  static async updateInventory(
    customerId: string,
    inventoryId: number,
    inventoryEntries: Entry[],
    state: string
  ) {
    return await apiRequest
      .put(config.api.inventory.inventory.update(customerId, inventoryId))
      .send({
        id: inventoryId,
        customer_id: customerId,
        state_name: state,
        entries: inventoryEntries
      });
  }

  static async updateInventoryState(
    customerId: string,
    inventoryId: number,
    state: string
  ) {
    return await apiRequest
      .patch(config.api.inventory.inventory.update(customerId, inventoryId))
      .send({
        id: inventoryId,
        state_name: state
      });
  }
}
